
export const countryNameFromCountryCode = ( countryCode ) =>
{
    if ( countryCode === "CZ" ) {
        return "Česká republika";
    }
    else
    {
        return countryCode;
    }
};



// WEBPACK FOOTER //
// ./src/Atollon/CountryCodes.js